<div class="search-bar-layout animated fadeIn">
    <!-- Mobile-only top bar with Cancel action -->
    <div class="searchbar-mobile-topbar d-lg-none">
        <button type="button" class="searchbar-cancel" (click)="cancelMobile()"
            aria-label="Cancel search">Cancel</button>
    </div>

    <div class="search-wrap">
        <form class="searchbar-form" role="search" (ngSubmit)="onSearchSubmit()">
            <div class="searchbar-container">
                <i class="fa-solid fa-magnifying-glass searchbar-icon-leading" aria-hidden="true"></i>

                <input #searchInput class="searchbar-input"
                    type="search"
                    inputmode="search"
                    enterkeyhint="search"
                    role="combobox"
                    aria-label="Search products"
                    aria-autocomplete="list"
                    aria-controls="search-listbox"
                    [attr.aria-expanded]="showDropdown()"
                    [attr.aria-activedescendant]="selectedIndex >= 0 ? 'search-option-' + selectedIndex : null"
                    placeholder="Search"
                    (keydown)="onInputKeydown($event)" [(ngModel)]="searchBarContent" [ngModelOptions]="{standalone: true}"
                    (input)="inputSearchTypeHandler($event)"
                    (focus)="onSearchFocus()"
                    (blur)="onSearchBlur($event)"
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false" />

                <div class="searchbar-actions">
                    @if (isLoadingSuggestions()) {
                        <span class="spinner-border spinner-border-sm searchbar-inline-spinner" role="status" aria-hidden="true"></span>
                    }
                    @if (searchBarContent()) {
                        <button type="button" class="searchbar-btn searchbar-btn--clear"
                            (mousedown)="$event.preventDefault(); clearSearchInput()" title="Clear" aria-label="Clear search">
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                    }
                    <span class="searchbar-divider"></span>
                    <button type="submit" class="searchbar-btn searchbar-btn--search"
                        (mousedown)="$event.preventDefault()" title="Search" aria-label="Search">
                        <i class="fa-solid fa-magnifying-glass"></i>
                    </button>
                    <button type="button" class="searchbar-btn searchbar-btn--close"
                        (click)="toggleSearchBar()" title="Clear filters and close search" aria-label="Clear filters and close search">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
            </div>
        </form>

        <!-- Autocomplete Dropdown -->
        @if (showDropdown()) {
        <div id="search-listbox" role="listbox" class="autocomplete-dropdown position-absolute w-100 bg-white mt-1">

                <!-- Cold-load spinner: only when we have no products at all to show -->
                @if (isLoadingPopular() && !popularProducts().length && !suggestions().length) {
                <div class="autocomplete-loading py-4 text-center text-muted">
                    <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                    Searching...
                </div>
                } @else {

                @let nav = flatNavItems();

                <div class="autocomplete-content d-flex" [class.is-loading]="isLoadingSuggestions()">
                    <!-- Left Column: Query Suggestions / Recents / Popular -->
                    <div class="autocomplete-suggestions">
                        @if (!isQuerying() && recentSearches().length > 0) {
                            <div class="suggestions-header suggestions-header--with-action">
                                <span>Recent</span>
                                <button type="button" class="suggestions-header__action"
                                    (mousedown)="onClearRecent($event)">Clear</button>
                            </div>
                        } @else if (!isQuerying() && popularSearches().length > 0) {
                            <div class="suggestions-header">Popular Searches</div>
                        }

                        @for (item of nav.leftItems; track $index; let i = $index) {
                            @if (item.kind === 'search-all') {
                                <div class="suggestion-item suggestion-item--search-all"
                                    role="option"
                                    [id]="'search-option-' + i"
                                    [class.active]="selectedIndex === i"
                                    [attr.aria-selected]="selectedIndex === i"
                                    (mouseenter)="onItemHover(i)"
                                    (mousedown)="$event.preventDefault(); navigateToSearch(item.value)">
                                    <i class="fa-solid fa-arrow-right suggestion-icon"></i>
                                    <span class="suggestion-text">
                                        Search all for "<strong>{{ item.value }}</strong>"
                                    </span>
                                </div>
                            } @else if (item.kind === 'recent') {
                                <div class="suggestion-item suggestion-item--removable"
                                    role="option"
                                    [id]="'search-option-' + i"
                                    [class.active]="selectedIndex === i"
                                    [attr.aria-selected]="selectedIndex === i"
                                    (mouseenter)="onItemHover(i)"
                                    (mousedown)="$event.preventDefault(); navigateToSearch(item.value)">
                                    <i class="fa-solid fa-clock-rotate-left suggestion-icon"></i>
                                    <span class="suggestion-text">{{ item.value }}</span>
                                    <button type="button" class="suggestion-item__remove"
                                        aria-label="Remove from recent searches"
                                        (mousedown)="onLeftItemRemove($event, item.value)">
                                        <i class="fa-solid fa-xmark"></i>
                                    </button>
                                </div>
                            } @else {
                                <div class="suggestion-item"
                                    role="option"
                                    [id]="'search-option-' + i"
                                    [class.active]="selectedIndex === i"
                                    [attr.aria-selected]="selectedIndex === i"
                                    (mouseenter)="onItemHover(i)"
                                    (mousedown)="$event.preventDefault(); navigateToSearch(item.value)">
                                    <i class="fa-solid fa-magnifying-glass suggestion-icon"></i>
                                    <span class="suggestion-text">{{ item.value }}</span>
                                </div>
                            }
                        }
                    </div>

                    <!-- Right Column: Product Cards Grid -->
                    <div class="autocomplete-products">
                        <div class="products-header">
                            {{ productsHeaderText() }}
                            @if (nav.products.length > 0) {
                                <span class="products-count">({{ nav.products.length }})</span>
                            }
                        </div>

                        @if (nav.products.length > 0) {
                        <div class="products-grid">
                            @for (product of nav.products; track product.id; let i = $index) {
                                @let productIdx = nav.leftItems.length + i;
                                <app-autocomplete-product-card
                                    role="option"
                                    [id]="'search-option-' + productIdx"
                                    [attr.aria-selected]="selectedIndex === productIdx"
                                    [product]="product"
                                    [active]="selectedIndex === productIdx"
                                    [isLoading]="addingToCartProductId() === product.id"
                                    [hasSession]="hasSession()"
                                    (mouseenter)="onItemHover(productIdx)"
                                    (productClick)="onProductCardClick($event)"
                                    (addToCartClick)="onProductAddToCart($event)">
                                </app-autocomplete-product-card>
                            }

                            @if (nav.hasSearchAllCard) {
                                <!-- Trailing tile: the grid only shows the first page of matches, so this
                                     is where the count of everything else lives. Same action as the left
                                     column's "Search all" row. -->
                                @let searchAllCardIdx = nav.leftItems.length + nav.products.length;
                                <button type="button"
                                        class="search-all-card"
                                        role="option"
                                        [id]="'search-option-' + searchAllCardIdx"
                                        [attr.aria-selected]="selectedIndex === searchAllCardIdx"
                                        [class.is-active]="selectedIndex === searchAllCardIdx"
                                        (mouseenter)="onItemHover(searchAllCardIdx)"
                                        (mousedown)="$event.preventDefault(); navigateToSearch(searchBarContent())">
                                    <span class="search-all-card__text">
                                        Search all {{ suggestionsTotalFound() }} products for
                                        "<strong>{{ searchBarContent() }}</strong>"
                                    </span>
                                    <i class="fa-solid fa-arrow-right search-all-card__icon" aria-hidden="true"></i>
                                </button>
                            }
                        </div>
                        } @else if (!isLoadingSuggestions() && !isLoadingPopular()) {
                        <div class="products-empty py-4 text-center text-muted">
                            <i class="fa-solid fa-box-open mb-2" style="font-size: 24px;"></i>
                            <p class="mb-0">No products found</p>
                        </div>
                        }
                    </div>
                </div>
            }
        </div>
        }
    </div>
</div>
